module.exports = __webpack_public_path__ + "static/media/skyCycling.bdb4aed6.jpg";